import { styled } from '@mui/material/styles';
import { List } from '@sunwisesoftware/sunwise-ui';

export default styled(List)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: 0,
}));
